/* eslint-disable quote-props */
import { put, call, takeEvery, select } from 'redux-saga/effects';

import { fetchApi } from '../utils/api';

import {
    getLanguagesSuccess,
    getLanguagesFailure,
} from './languageActions';

import { trackEventRequest } from '../analytics/analyticsActions';

const {
    GET_LANGUAGES_REQUEST,
    SELECT_LANGUAGE_REQUEST,
} = require('./languageActions').constants;

function* getLanguages() {

    try {
        const response = yield call(fetchApi, {
            method: 'GET',
            url: '/language/list',
        });

        yield put(getLanguagesSuccess(response));
    } catch (e) {
        yield put(getLanguagesFailure(e.response ? e.response.data.message : e));
    }
}

function* selectLanguage(action) {
    const { languages } = yield select(state => state.language);
    const selectedLang = languages.find(lang => lang.id === action.payload);

    // Track language change event
    yield put(trackEventRequest({
        eventType: 'change_language',
        eventCategory: 'settings',
        eventLabel: selectedLang?.name || action.payload,
        eventData: { language_id: action.payload },
    }));
}

export default function* authSaga() {
    yield* [
        takeEvery(GET_LANGUAGES_REQUEST, getLanguages),
        takeEvery(SELECT_LANGUAGE_REQUEST, selectLanguage),
    ];
}
